import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "@/lib/motion";
import { FARMERS_PREFER, IMAGES } from "@/data/content";

export default function FarmersPrefer() {
  return (
    <section data-testid="farmers-prefer" className="relative py-24 lg:py-32 overflow-hidden bg-brand-blueDark">
      <div className="absolute inset-0 opacity-20">
        <img src={IMAGES.cropRows} alt="" aria-hidden="true" className="size-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-brand-blueDark/70" />
      <div className="grain" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-greenLight mb-4">Why Modern Farmers Prefer Our Machinery</p>
          <h2 className="font-heading font-bold text-brand-cream tracking-tight text-3xl sm:text-5xl max-w-2xl leading-[1.05]">
            Outcomes that show up in every harvest.
          </h2>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4"
        >
          {FARMERS_PREFER.map((item) => {
            const Icon = Icons[item.icon] || Icons.Sprout;
            return (
              <motion.div
                key={item.title}
                variants={staggerItem}
                data-testid={`prefer-${item.icon}`}
                className="group rounded-xl border border-brand-cream/15 bg-brand-cream/5 backdrop-blur-sm p-5 hover:bg-brand-green transition-colors"
              >
                <Icon className="size-6 text-brand-greenLight group-hover:text-brand-cream transition-colors mb-4" />
                <h3 className="font-heading font-semibold text-sm text-brand-cream leading-tight">{item.title}</h3>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
